import 'reflect-metadata';
import { injectable } from 'inversify';
import { unit_carac_full } from '@Api';
import { UnitCarac, UnitCaracType } from '@Models';

@injectable()
export class UnitCaracMapper {
  public map(item: unit_carac_full): UnitCarac {
    return {
      ground_adv: item.adv,
      aeg: item.aeg,
      arm: item.arm,
      def: item.def,
      dis: item.dis,
      evoked: item.evoked,
      hp: item.hp,
      ground_mar: item.mar,
      res: item.res,
      type: this.mapType(item.version),
      fly_adv: item.fly_adv,
      fly_mar: item.fly_mar,
      unitType: item.type,
      unitBase: item.base,
      unitHeight: item.height,
    } satisfies UnitCarac as UnitCarac;
  }

  public mapType(item: unit_carac_full.version): UnitCaracType {
    switch (item) {
      case unit_carac_full.version.V2:
        return UnitCaracType.V2;
      case unit_carac_full.version.V3:
        return UnitCaracType.V3;
    }

    return UnitCaracType.V1;
  }
}
